export default {
  props: ["headers", "items", "noDataText", "features", "backTo"],
  data: () => ({
    page: 1,
    itemsPerPage: 10,
    filter: {
      s: ""
    }
  }),
  methods: {
    getFeatureTitleById(featureId) {
      if (!this.features.length) {
        return "";
      }
      return this.features.find(feature => feature._id === featureId)?.title;
    },
    nextPage() {
      const pages = Math.ceil(this.cItems.length / this.itemsPerPage);
      if (this.page < pages) {
        this.page++;
      }
    },
    previousPage() {
      if (this.page > 1) {
        this.page--;
      }
    }
  }
};
